// extracted by mini-css-extract-plugin
export default {"page":"style_page__d2oCr","content":"style_content__VRz0p","description":"style_description__5dVMA","contact":"style_contact__4bxN6","emailLink":"style_emailLink__MsZ0I"};